define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function WrongDestinationPathFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    WrongDestinationPathFail.WEB_BACKEND_ERROR = 'not_dir';

    WrongDestinationPathFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: WrongDestinationPathFail,
        className: 'WrongDestinationPathFail',
        radarName: 'fail_{SOURCE}_wrong-path',
        message: 'Путь, по которому вы пытаетесь загрузить папку, является файлом.',
    });

    module.exports = WrongDestinationPathFail;
});
